/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter, Navigate } from 'react-router';
import RootLayout from '@/modules/global-components/RootLayout';
import NotFoundPage from '@/modules/global-components/not-found';
import { authRoutes } from './auth/routes';
import { mainRoutes } from './main/routes';
import ErrorPage from '@/modules/auth/error/ErrorPage';
import { lazy } from 'react';
import SignOutPage from '@/modules/global-components/SignOutPage';

const ViewCustomerInvoice = lazy(
  () => import('@/modules/public-routes/view-invoice/ViewCustomerInvoice'),
);
const ViewInvoice = lazy(
  () => import('@/modules/public-routes/view-invoice/ViewInvoice'),
);

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/auth/login" replace />,
      },
      {
        path: 'public',
        children: [
          {
            path: 'view',
            children: [
              { path: 'document', Component: ViewInvoice },
              { path: 'invoice', Component: ViewCustomerInvoice },
            ],
          },
        ],
      },
      ...authRoutes,
      ...mainRoutes,
      { path: 'blank', Component: SignOutPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
